import React, { useState, Component } from 'react';
import { Link } from 'react-router-dom';
import { Shield, CheckCircle, ArrowRight, Star, Brain, Menu, X, Users, Lock, Calendar, Zap } from 'lucide-react';
import { motion, useScroll, useTransform, AnimatePresence } from 'framer-motion';
import { HowItWorks } from '../components/landing/HowItWorks';
import { Footer } from '../components/landing/Footer';
export function LandingPage() {
  const {
    scrollY
  } = useScroll();
  const y1 = useTransform(scrollY, [0, 500], [0, 200]);
  const y2 = useTransform(scrollY, [0, 500], [0, -150]);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  return <div className="bg-white overflow-hidden" data-id="element-3435">
      {/* Header */}
      <header className="fixed w-full bg-white/80 backdrop-blur-xl z-50 border-b border-gray-100 transition-all duration-300" data-id="element-3436">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between" data-id="element-3437">
          <Link to="/" className="flex items-center group" data-id="element-3438">
            <img src="https://cdn.magicpatterns.com/uploads/7EjErFNEa8ZC1es35aEHqt/RENTA_logo.png" alt="Renta" className="h-10 sm:h-12 w-auto transition-transform duration-300 group-hover:scale-105" data-id="element-3439" />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-3440">
            <a href="#features" className="text-gray-600 hover:text-blue-600 font-medium transition-colors" data-id="element-3441">
              Features
            </a>
            <a href="#how-it-works" className="text-gray-600 hover:text-blue-600 font-medium transition-colors" data-id="element-3442">
              How it Works
            </a>
            <a href="#stakeholders" className="text-gray-600 hover:text-blue-600 font-medium transition-colors" data-id="element-3443">
              For Landlords
            </a>
            <Link to="/login" className="text-gray-900 font-medium hover:text-blue-700 transition-colors" data-id="element-3444">
              Log in
            </Link>
            <Link to="/signup" className="bg-blue-600 text-white px-6 py-2.5 rounded-full font-medium hover:bg-blue-700 transition-all shadow-lg shadow-blue-600/20 hover:shadow-blue-600/30 hover:-translate-y-0.5" data-id="element-3445">
              Get Started
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsMobileMenuOpen(true)} className="md:hidden p-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors" aria-label="Open menu" data-id="element-3446">
            <Menu size={24} data-id="element-3447" />
          </button>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-3448">
        {isMobileMenuOpen && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setIsMobileMenuOpen(false)} className="fixed inset-0 bg-black/50 z-[60] md:hidden backdrop-blur-sm" data-id="element-3449" />

            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 30
        }} className="fixed top-0 right-0 bottom-0 w-full max-w-sm bg-white z-[70] md:hidden shadow-2xl" data-id="element-3450">
              <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-3451">
                <img src="https://cdn.magicpatterns.com/uploads/7EjErFNEa8ZC1es35aEHqt/RENTA_logo.png" alt="Renta" className="h-10 w-auto" data-id="element-3452" />
                <button onClick={() => setIsMobileMenuOpen(false)} className="p-2 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors" aria-label="Close menu" data-id="element-3453">
                  <X size={24} data-id="element-3454" />
                </button>
              </div>

              <nav className="p-6 space-y-1" data-id="element-3455">
                <a href="#features" onClick={() => setIsMobileMenuOpen(false)} className="block px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-blue-600 rounded-lg font-medium transition-colors" data-id="element-3456">
                  Features
                </a>
                <a href="#how-it-works" onClick={() => setIsMobileMenuOpen(false)} className="block px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-blue-600 rounded-lg font-medium transition-colors" data-id="element-3457">
                  How it Works
                </a>
                <a href="#stakeholders" onClick={() => setIsMobileMenuOpen(false)} className="block px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-blue-600 rounded-lg font-medium transition-colors" data-id="element-3458">
                  For Landlords
                </a>
                <Link to="/login" className="block px-4 py-3 text-gray-700 hover:bg-gray-50 hover:text-blue-600 rounded-lg font-medium transition-colors" data-id="element-3459">
                  Log in
                </Link>
              </nav>

              <div className="p-6 space-y-3 border-t border-gray-100" data-id="element-3460">
                <Link to="/signup" className="block w-full text-center px-6 py-3 bg-blue-600 text-white rounded-full font-bold hover:bg-blue-700 transition-colors shadow-lg" data-id="element-3461">
                  Get Started
                </Link>
              </div>

              <div className="p-6 space-y-3" data-id="element-3462">
                <div className="flex items-center text-sm text-gray-600" data-id="element-3463">
                  <Shield className="h-5 w-5 text-green-500 mr-2" data-id="element-3464" />
                  Bank-Grade Security
                </div>
                <div className="flex items-center text-sm text-gray-600" data-id="element-3465">
                  <Brain className="h-5 w-5 text-purple-500 mr-2" data-id="element-3466" />
                  AI-Powered Risk Scoring
                </div>
                <div className="flex items-center text-sm text-gray-600" data-id="element-3467">
                  <Star className="h-5 w-5 text-yellow-500 mr-2 fill-yellow-500" data-id="element-3468" />
                  4.9/5 User Rating
                </div>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden" data-id="element-3469">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-3470">
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-400/20 rounded-full blur-3xl animate-pulse" data-id="element-3471"></div>
          <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-green-400/20 rounded-full blur-3xl animate-pulse delay-1000" data-id="element-3472"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-3473">
          <div className="text-center max-w-5xl mx-auto" data-id="element-3474">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-3475">
              <span className="inline-flex items-center px-4 py-1.5 rounded-full bg-gradient-to-r from-blue-50 to-green-50 text-blue-700 text-sm font-semibold mb-8 border border-blue-100 shadow-sm" data-id="element-3476">
                <Brain className="w-4 h-4 mr-2" data-id="element-3477" />
                AI-Powered Rent Infrastructure
              </span>
              <h1 className="text-5xl md:text-7xl font-extrabold text-gray-900 tracking-tight mb-8 leading-tight" data-id="element-3478">
                Pay Rent Monthly. <br className="hidden md:block" data-id="element-3479" />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-green-600" data-id="element-3480">
                  Live Stress-Free.
                </span>
              </h1>
              <p className="text-xl md:text-2xl text-gray-600 mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-3481">
                Nigeria's first <strong data-id="element-3482">AI-driven rent platform</strong>.
                Tenants pay monthly, landlords get paid upfront. Simple, secure,
                and smart.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="flex flex-col sm:flex-row justify-center gap-4 mb-16" data-id="element-3483">
              <Link to="/get-started" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-full text-white bg-blue-600 hover:bg-blue-700 shadow-xl shadow-blue-600/30 transition-all hover:scale-105 hover:-translate-y-1" data-id="element-3484">
                Start as Tenant
                <ArrowRight className="ml-2 h-5 w-5" data-id="element-3485" />
              </Link>
              <Link to="/get-started?role=landlord" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-full text-white bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 shadow-xl shadow-green-600/30 transition-all hover:scale-105 hover:-translate-y-1" data-id="element-3486">
                Start as Landlord
                <ArrowRight className="ml-2 h-5 w-5" data-id="element-3487" />
              </Link>
            </motion.div>

            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} className="flex flex-wrap justify-center items-center gap-4 sm:gap-8 text-sm font-medium text-gray-500" data-id="element-3488">
              <div className="flex items-center bg-white px-4 py-2 rounded-full shadow-sm border border-gray-100" data-id="element-3489">
                <Shield className="h-5 w-5 text-green-500 mr-2" data-id="element-3490" />
                <span className="hidden sm:inline" data-id="element-3491">Bank-Grade Security</span>
                <span className="sm:hidden" data-id="element-3492">Secure</span>
              </div>
              <div className="flex items-center bg-white px-4 py-2 rounded-full shadow-sm border border-gray-100" data-id="element-3493">
                <Brain className="h-5 w-5 text-purple-500 mr-2" data-id="element-3494" />
                <span className="hidden sm:inline" data-id="element-3495">
                  AI-Powered Risk Scoring
                </span>
                <span className="sm:hidden" data-id="element-3496">AI-Powered</span>
              </div>
              <div className="flex items-center bg-white px-4 py-2 rounded-full shadow-sm border border-gray-100" data-id="element-3497">
                <Star className="h-5 w-5 text-yellow-500 mr-2 fill-yellow-500" data-id="element-3498" />
                4.9/5 Rating
              </div>
            </motion.div>
          </div>
        </div>

        {/* Floating UI Elements */}
        <motion.div style={{
        y: y1
      }} className="absolute top-1/4 left-10 hidden lg:block" data-id="element-3499">
          <div className="bg-white p-4 rounded-2xl shadow-xl border border-gray-100 max-w-xs transform -rotate-6" data-id="element-3500">
            <div className="flex items-center mb-3" data-id="element-3501">
              <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mr-3" data-id="element-3502">
                <CheckCircle className="w-6 h-6 text-green-600" data-id="element-3503" />
              </div>
              <div data-id="element-3504">
                <p className="font-bold text-gray-900" data-id="element-3505">Monthly Payment</p>
                <p className="text-xs text-gray-500" data-id="element-3506">Auto-deducted</p>
              </div>
            </div>
            <div className="h-2 bg-gray-100 rounded-full overflow-hidden" data-id="element-3507">
              <div className="h-full w-full bg-green-500 rounded-full" data-id="element-3508"></div>
            </div>
          </div>
        </motion.div>

        <motion.div style={{
        y: y2
      }} className="absolute bottom-1/4 right-10 hidden lg:block" data-id="element-3509">
          <div className="bg-white p-4 rounded-2xl shadow-xl border border-gray-100 max-w-xs transform rotate-6" data-id="element-3510">
            <div className="flex items-center mb-3" data-id="element-3511">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-3" data-id="element-3512">
                <Calendar className="w-6 h-6 text-blue-600" data-id="element-3513" />
              </div>
              <div data-id="element-3514">
                <p className="font-bold text-gray-900" data-id="element-3515">Flexible Schedule</p>
                <p className="text-xs text-green-600 font-bold" data-id="element-3516">Pay Monthly</p>
              </div>
            </div>
            <div className="text-2xl font-bold text-gray-900" data-id="element-3517">
              ₦150,000{' '}
              <span className="text-sm text-gray-400 font-normal" data-id="element-3518">/month</span>
            </div>
          </div>
        </motion.div>
      </section>

      {/* How It Works */}
      <HowItWorks data-id="element-3519" />

      {/* 2-Sided Platform */}
      <section id="stakeholders" className="py-24 bg-white" data-id="element-3520">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3521">
          <div className="text-center mb-20" data-id="element-3522">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-3523">
              A Win-Win Ecosystem
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-3524">
              Connecting tenants and landlords in a transparent, AI-powered
              platform
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-3525">
            <div className="bg-white p-8 rounded-3xl shadow-lg border border-gray-100" data-id="element-3526">
              <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mb-6" data-id="element-3527">
                <Users className="h-8 w-8 text-blue-600" data-id="element-3528" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-3529">Tenants</h3>
              <ul className="space-y-3 text-gray-600" data-id="element-3530">
                <li className="flex items-start" data-id="element-3531">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-3532" />
                  Pay rent monthly instead of annually
                </li>
                <li className="flex items-start" data-id="element-3533">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-3534" />
                  Auto-debit from salary account
                </li>
                <li className="flex items-start" data-id="element-3535">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-3536" />
                  Build rent credit score
                </li>
                <li className="flex items-start" data-id="element-3537">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-3538" />
                  AI cashflow predictions
                </li>
              </ul>
              <Link to="/get-started" className="mt-6 w-full inline-flex items-center justify-center px-6 py-3 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700 transition-colors" data-id="element-3539">
                Start as Tenant
              </Link>
            </div>

            <div className="bg-gradient-to-br from-green-600 to-emerald-600 p-8 rounded-3xl shadow-lg text-white transform md:scale-105" data-id="element-3540">
              <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mb-6 backdrop-blur-sm" data-id="element-3541">
                <Shield className="h-8 w-8 text-white" data-id="element-3542" />
              </div>
              <h3 className="text-2xl font-bold mb-4" data-id="element-3543">Landlords</h3>
              <ul className="space-y-3" data-id="element-3544">
                <li className="flex items-start" data-id="element-3545">
                  <CheckCircle className="h-5 w-5 mr-2 mt-0.5 flex-shrink-0" data-id="element-3546" />
                  Get paid upfront
                </li>
                <li className="flex items-start" data-id="element-3547">
                  <CheckCircle className="h-5 w-5 mr-2 mt-0.5 flex-shrink-0" data-id="element-3548" />
                  100% payment guarantee
                </li>
                <li className="flex items-start" data-id="element-3549">
                  <CheckCircle className="h-5 w-5 mr-2 mt-0.5 flex-shrink-0" data-id="element-3550" />
                  Zero default risk
                </li>
                <li className="flex items-start" data-id="element-3551">
                  <CheckCircle className="h-5 w-5 mr-2 mt-0.5 flex-shrink-0" data-id="element-3552" />
                  Tenant reliability scores
                </li>
              </ul>
              <Link to="/get-started?role=landlord" className="mt-6 w-full inline-flex items-center justify-center px-6 py-3 bg-white text-green-600 rounded-xl font-bold hover:bg-gray-50 transition-colors" data-id="element-3553">
                Start as Landlord
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* AI Features */}
      <section id="features" className="py-24 bg-gray-50" data-id="element-3554">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3555">
          <div className="text-center mb-20" data-id="element-3556">
            <span className="inline-flex items-center px-4 py-1.5 rounded-full bg-purple-100 text-purple-700 text-sm font-semibold mb-4" data-id="element-3557">
              <Brain className="w-4 h-4 mr-2" data-id="element-3558" />
              Powered by Artificial Intelligence
            </span>
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-3559">
              Smart Features for Everyone
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-3560">
              Our AI engine predicts, protects, and optimizes every transaction
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-3561">
            {[{
            icon: Brain,
            title: 'AI Risk Scoring',
            desc: 'Machine learning models assess tenant reliability in real-time with 95% accuracy.',
            color: 'purple'
          }, {
            icon: Calendar,
            title: 'Cashflow Prediction',
            desc: 'Predict payment stress 30 days in advance and get personalized financial advice.',
            color: 'blue'
          }, {
            icon: Shield,
            title: 'Fraud Detection',
            desc: 'Advanced anomaly detection identifies suspicious activity before it becomes a problem.',
            color: 'red'
          }, {
            icon: Zap,
            title: 'Smart Notifications',
            desc: 'Context-aware alerts delivered at the right time with actionable insights.',
            color: 'yellow'
          }, {
            icon: Lock,
            title: 'Escrow Protection',
            desc: 'Automated ledger tracks every naira with full transparency and audit trails.',
            color: 'orange'
          }, {
            icon: CheckCircle,
            title: 'Auto-Debit',
            desc: 'Seamless integration with payroll systems for hassle-free monthly payments.',
            color: 'green'
          }].map((feature, idx) => <motion.div key={idx} whileHover={{
            y: -10
          }} className="bg-white p-8 rounded-3xl shadow-sm border border-gray-100 hover:shadow-xl transition-all duration-300" data-id="element-3562">
                <div className={`h-14 w-14 rounded-2xl flex items-center justify-center mb-6 bg-${feature.color}-50`} data-id="element-3563">
                  <feature.icon className={`h-7 w-7 text-${feature.color}-600`} data-id="element-3564" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-3565">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-3566">{feature.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 relative overflow-hidden" data-id="element-3567">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900 via-blue-800 to-green-900" data-id="element-3568">
          <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-3569"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-3570">
          <div className="text-center text-white" data-id="element-3571">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-3572">
              Ready to Transform Your Rent Experience?
            </h2>
            <p className="text-blue-100 text-xl mb-12 max-w-2xl mx-auto" data-id="element-3573">
              Join thousands of tenants and landlords building a better rental
              ecosystem
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-3574">
              <Link to="/get-started" className="inline-flex items-center justify-center px-8 py-4 bg-white text-blue-900 rounded-full font-bold hover:bg-blue-50 transition-all transform hover:scale-105 shadow-lg" data-id="element-3575">
                Get Started Free <ArrowRight className="ml-2 h-5 w-5" data-id="element-3576" />
              </Link>
              <a href="#how-it-works" className="inline-flex items-center justify-center px-8 py-4 border-2 border-white text-white rounded-full font-bold hover:bg-white/10 transition-all" data-id="element-3577">
                Learn More
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer data-id="element-3578" />
    </div>;
}